// Thin client for the v1 API. Independent of the legacy url/apiURL.js (which force-
// rewrites to production). Tokens are kept per-role so customer/guest/vendor demo
// tabs don't clobber each other.
const BASE = (process.env.REACT_APP_BASE_URL || "http://localhost:3008") + "/api/v1";

const KEY = (scope) => `avah_rsa_token_${scope}`;
export const setToken = (scope, t) => localStorage.setItem(KEY(scope), t);
export const getToken = (scope) => localStorage.getItem(KEY(scope));
export const clearToken = (scope) => localStorage.removeItem(KEY(scope));

export async function api(method, path, { token, body, scope } = {}) {
  const t = token || (scope ? getToken(scope) : null);
  const res = await fetch(BASE + path, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(t ? { Authorization: `Bearer ${t}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = { raw: text }; }
  if (!res.ok) {
    // RFC 9457 problem+json -> Error with title/detail/status
    const err = new Error(data?.detail || data?.title || `HTTP ${res.status}`);
    err.status = res.status;
    err.problem = data;
    throw err;
  }
  return data;
}

export const API_BASE = BASE;
